import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';
import { Text, TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';

import { useMemberHandlers } from '../../../../contexts/widgets';
import settingsParams from '../../settingsParams';
import { classes, st } from './EmptyState.st.css';

interface EmptyStateProps {
  isBlocked: boolean;
}

export const EmptyState: FC<EmptyStateProps> = ({ isBlocked }) => {
  const settings = useSettings();
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();
  const { navigateToMyAccount } = useMemberHandlers();

  const title = isBlocked
    ? t('no-about.blocked-member.content')
    : settings.get(settingsParams.emptyStateTitle);

  const titleHtmlTag = settings.get(settingsParams.emptyStateTitleHtmlTag);

  return (
    <div className={st(classes.root, { mobile: isMobile })}>
      <div className={classes.content}>
        <Text tagName={titleHtmlTag} className={classes.title}>
          {title}
        </Text>
        {isBlocked ? (
          <TextButton
            className={classes.myAccountLink}
            priority={TextButtonPriority.primary}
            onClick={() => navigateToMyAccount()}
          >
            {t('no-about.blocked-member.my-account-link')}
          </TextButton>
        ) : (
          <Text tagName="p" className={classes.description}>
            {settings.get(settingsParams.emptyStateText)}
          </Text>
        )}
      </div>
    </div>
  );
};
